'use client';

import { DepositIcon } from '@repo/icons';
import { Button } from '@repo/ui/button';
import { cn } from '@repo/utils/cn';
import { useTranslations } from 'next-intl';
import { useAppStore } from '@/providers/AppStoreProvider';

type DepositButtonProps = {
  className?: string;
};

const DepositButton = ({ className }: DepositButtonProps) => {
  const t = useTranslations('header');

  const { setIsQuickDepositOpen } = useAppStore((state) => ({
    setIsQuickDepositOpen: state.setIsQuickDepositOpen,
  }));

  return (
    <Button
      asChild
      variant="primary"
      className={cn('h-full rounded-full !px-2 sm:!px-3', className)}
      onClick={() => setIsQuickDepositOpen(true)}
    >
      <div className="flex items-center">
        <span className="hidden sm:flex">{t('deposit')}</span>
        <DepositIcon className="flex sm:hidden" />
      </div>
    </Button>
  );
};

export default DepositButton;
